import { type StateCreator } from "zustand";
import { TDataIngEntityIntegrationPartnerEditResData } from "../../api/data-ingestion/data-ingestion.types";

export type TDataIngestionStoreState = {
  connectionStatus: boolean;
  isEditMode: boolean;
  isEntityAvailable: boolean;
  editData: TDataIngEntityIntegrationPartnerEditResData;
  configFields?: any[];
} & Partial<Record<string, any>>;

export type TDataIngestionStoreActions = {
  setTestConnectionStatus: (value: boolean) => void;
  setIsEditMode: (value: boolean) => void;
  setEditData: (value: TDataIngEntityIntegrationPartnerEditResData) => void;
  setIsEntityAvailable: (value: boolean) => void;
  setConfigFields: (fields: any[]) => void;
};

const initialDataIngestionStoreState: TDataIngestionStoreState = {
  connectionStatus: false,
  isEditMode: false,
  isEntityAvailable: true,
  editData: {
    internal_id: "",
    integration_partner: {
      id: "",
      name: "",
      slug: "",
    },
    entity_internal_id: "",
    capabilities: "",
    configuration: {},
    field_mappings: [],
  },
  configFields: [],
};

export type TDataIngestionStore = TDataIngestionStoreActions &
  TDataIngestionStoreState;

export const CreateDataIngestionSlice: StateCreator<TDataIngestionStore> = (
  set,
) => ({
  ...initialDataIngestionStoreState,
  setTestConnectionStatus: (value: boolean) => set({ connectionStatus: value }),
  setIsEditMode: (value: boolean) => set({ isEditMode: value }),
  setEditData: (value: TDataIngEntityIntegrationPartnerEditResData) =>
    set({ editData: value }),
  setIsEntityAvailable: (value: boolean) => set({ isEditMode: value }),
  setConfigFields: (fields: any[]) => set({ configFields: fields }),
});
